import { render, staticRenderFns } from "./PremiumFeatures.vue?vue&type=template&id=f4955fe8&scoped=true&"
import script from "./PremiumFeatures.vue?vue&type=script&lang=ts&"
export * from "./PremiumFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumFeatures.vue?vue&type=style&index=0&id=f4955fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4955fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f4955fe8', component.options)
    } else {
      api.reload('f4955fe8', component.options)
    }
    module.hot.accept("./PremiumFeatures.vue?vue&type=template&id=f4955fe8&scoped=true&", function () {
      api.rerender('f4955fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/PremiumFeatures.vue"
export default component.exports